const SECOND = 1000;
const MINUTE = SECOND * 60;

export const TIME = {
    SECOND,
    MINUTE,
};
